import React from 'react';
import Icon from '../../../components/AppIcon';

const RecentActivityItem = ({ type, title, score, questionsCount, timestamp, knowledgeArea }) => {
  const getActivityIcon = (activityType) => {
    switch (activityType) {
      case 'test':
        return { name: 'FileText', bg: 'bg-primary' };
      case 'practice':
        return { name: 'BookOpen', bg: 'bg-secondary' };
      case 'milestone':
        return { name: 'Award', bg: 'bg-success' };
      case 'bookmark':
        return { name: 'Bookmark', bg: 'bg-accent' };
      default:
        return { name: 'Activity', bg: 'bg-muted' };
    }
  };

  const getScoreColor = (scoreValue) => {
    if (scoreValue >= 85) return 'text-success';
    if (scoreValue >= 70) return 'text-primary';
    if (scoreValue >= 50) return 'text-warning';
    return 'text-error';
  };

  const activityIcon = getActivityIcon(type);
  const scoreColor = score ? getScoreColor(score) : '';

  return (
    <div className="flex items-start gap-3 md:gap-4 p-3 md:p-4 bg-muted/30 rounded-lg transition-smooth hover:bg-muted/50">
      <div className={`w-8 h-8 md:w-10 md:h-10 rounded-lg flex items-center justify-center flex-shrink-0 ${activityIcon?.bg}`}>
        <Icon name={activityIcon?.name} size={16} color="white" />
      </div>
      <div className="flex-1 min-w-0">
        <h5 className="text-sm md:text-base font-medium text-foreground mb-1 line-clamp-1">
          {title}
        </h5>
        <div className="flex flex-wrap items-center gap-2 text-xs md:text-sm text-muted-foreground">
          {knowledgeArea && (
            <span className="flex items-center gap-1">
              <Icon name="BookOpen" size={12} />
              <span className="line-clamp-1">{knowledgeArea}</span>
            </span>
          )}
          {questionsCount && (
            <span className="flex items-center gap-1">
              <Icon name="HelpCircle" size={12} />
              <span className="data-text whitespace-nowrap">{questionsCount} questions</span>
            </span>
          )}
        </div>
      </div>
      <div className="flex flex-col items-end gap-1 flex-shrink-0">
        {score !== null && score !== undefined && (
          <span className={`text-sm md:text-base font-semibold ${scoreColor} data-text whitespace-nowrap`}>
            {score}%
          </span>
        )}
        <span className="text-xs text-muted-foreground whitespace-nowrap">{timestamp}</span>
      </div>
    </div>
  );
};

export default RecentActivityItem;